<template>
  <main class="layout" :id="id">
    <info-header
      id="header"
      class="fixed top-0 right-0 left-0"
      :isLanding="landingRoutes.includes($route.name)"
    />
    <div
      class="w-full relative max-w-[100vw] flex-1 flex flex-col justify-center items-center z-[0]"
      :style="{
        paddingTop: paddingTop,
      }"
    >
      <slot></slot>
    </div>
    <info-footer class="w-full" />
  </main>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import PropTypes from '@/helpers/propTypes';
import { ROUTE_NAMES } from '@/helpers/constants';
import { waitForElmAppear } from '@/helpers/helpers';
import { ResizeObserver } from 'resize-observer';

export default {
  name: 'main-non-authorize-layout',

  components: {
    InfoHeader: defineAsyncComponent(
      () =>
        import(
          /*webpackChunkName: "InfoHeader"*/ '../components/teamfu-info/home-header.vue'
        ),
    ),
    InfoFooter: defineAsyncComponent(
      () =>
        import(
          /*webpackChunkName: "InfoFooter"*/ '../components/teamfu-info/home-footer.vue'
        ),
    ),
  },

  props: {
    id: PropTypes.STR(),
  },

  data() {
    return {
      ROUTE_NAMES: ROUTE_NAMES,
      paddingTop: '80px',
      landingRoutes: [
        ROUTE_NAMES.LANDING,
        ROUTE_NAMES.ABOUT,
        ROUTE_NAMES.FEATURES,
        ROUTE_NAMES.INTEGRATIONS,
        ROUTE_NAMES.USE_CASES,
        ROUTE_NAMES.PRICING,
      ],
      roHeader: null,
    };
  },

  mounted() {
    this.setResizeObserver();
  },

  beforeUnmount() {
    if (this.roHeader) {
      this.roHeader.disconnect();
    }
  },

  methods: {
    setResizeObserver() {
      this.roHeader = new ResizeObserver(entries => {
        this.paddingTop =
          entries.reduce((acc, el) => acc + el.contentRect.height, 0) + 'px';
      });

      waitForElmAppear('#header').then(el => {
        this.roHeader.observe(el);
      });
    },
  },
};
</script>

<style scoped>
.layout {
  @apply w-full h-full flex flex-col grow bg-teamfu-g-000 relative justify-start items-stretch bg-no-repeat;

  align-content: stretch;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}
</style>
